import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinAreaRental = createAsyncThunk(
    "areaRental/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/AreaRental/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.AreaRentalID,
                        label: item.AreaRentalName,
                        CategoryID: item.CategoryID,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getAreaRental = createAsyncThunk(
    "areaRental/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/AreaRental/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertAreaRental = createAsyncThunk(
    "areaRental/insert",
    async ({AreaRentalName, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("AreaRentalName", AreaRentalName);
        formData.append("CategoryID", CategoryID);


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/AreaRental/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateAreaRental = createAsyncThunk(
    "areaRental/update",
    async ({AreaRentalName, AreaRentalID, status, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("AreaRentalName", AreaRentalName);
        formData.append("AreaRentalID", AreaRentalID);
        formData.append("Status", status);
        formData.append("CategoryID", CategoryID);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/AreaRental/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const areaRentalSlice = createSlice({
    name: "areaRental",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinAreaRental.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinAreaRental.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinAreaRental.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getAreaRental.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getAreaRental.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getAreaRental.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertAreaRental.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertAreaRental.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertAreaRental.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateAreaRental.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateAreaRental.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateAreaRental.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const areaRentalSelector = (state) => state.areaRental;
